let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l8igA")).then(() => parcelRequire('27EyS'));